import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

interface AuthState {
    user: null | {
        created_at: string;
        email: string;
        email_verified_at: string;
        id: number;
        image: null | string;
        name: string;
        phone: string;
        role: string;
        status: number;
        token: string;
        updated_at: string;
    };
    /** Sanctum `GET /me` payload (may include nested `employee` and extra HR fields) */
    me: Record<string, unknown> | null;
    token: null | string;
}

const initialState: AuthState = {
    user: null,
    me: null,
    token: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state, action: PayloadAction<{ user: any; token: string | null }>) => {
            state.user = action.payload.user;
            state.token = action.payload.token;

            if (action.payload.token) {
                Cookies.set('accessToken', action.payload.token);
            } else {
                Cookies.remove('accessToken');
                state.me = null;
            }
        },
        logout: (state) => {
            state.user = null;
            state.me = null;
            state.token = null;
            Cookies.remove('accessToken');
        },
        setMe: (state, action: PayloadAction<Record<string, unknown> | null>) => {
            state.me = action.payload;
        },
    },
});

export const { setCredentials, logout, setMe } = authSlice.actions;
export default authSlice.reducer;
